import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  h3 {
    margin-top: 0;
    font-weight: 600;
    padding-bottom: 13px;
    font-size: 14px;
    border-bottom: 1px solid #eee;
    margin-bottom: 0;
    color: ${COLORS.BODY_TEXT};
    padding-top: 15px;
  }
  border-bottom: 2px solid black;
  padding-bottom: 15px;
`;

const CloudWrapper = styled.div`
  display: flex;
  align-items: center;
  grid-gap: 5px;
  > svg {
    cursor: pointer;
  }
  > img {
    width: 34px;
    height: auto;
    max-height: 34px;
  }
`;

const ProductInformation = styled.div`
  .slick-prev {
    left: 0px;
  }
  .slick-next {
    right: 10px;
  }
  .slick-prev,
  .slick-next {
    display: block !important;
    z-index: 999;
  }
  .slick-next:before,
  .slick-prev:before {
    color: #1c84c6;
    opacity: 1;
    font-size: 30px;
  }
  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: 0.5;
  }
  h4 {
    font-size: 20px;
    margin-top: 0;
  }

  > h3 {
    margin-top: 0;
    font-weight: 600;
    padding-bottom: 13px;
    font-size: 14px;
    border-bottom: 1px solid #eee;
    margin-bottom: 0;
    color: ${COLORS.BODY_TEXT};
    padding-top: 15px;
    margin-bottom: 30px;
  }
  .MuiFormControl-root {
    width: 100%;
  }
  > div {
    margin: 15px 0;
    /* display: grid; */
    grid-template-columns: repeat(5, 1fr);
    margin-top: 0;
    align-items: center;
    flex-wrap: wrap;
  }
`;

const SelectCategories = styled.div`
  > h3 {
    margin-top: 0;
    font-weight: 600;
    padding-bottom: 13px;
    font-size: 14px;
    border-bottom: 1px solid #eee;
    margin-bottom: 0;
    color: ${COLORS.BODY_TEXT};
  }
`;

const Update = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  > button {
    background-color: ${COLORS.BLACK};
    font-size: 14px;
    border-radius: 3px;
    padding: 12px;
    line-height: 1.5;
    color: ${COLORS.WHITE};
    :hover {
      opacity: 0.8;
      background-color: ${COLORS.BLACK};
      color: ${COLORS.WHITE};
    }
  }
`;
const Wrapper = styled.div`
  display: flex;
  > div {
    flex: 1;
    margin-right: 20px;
    min-width: 200px;
    margin-bottom: 10px;
  }
`;
const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: auto;
  margin: 0 auto;
  width: 565px;
  height: 565px;
  > img {
    width: 565px;
    height: 565px;
  }
`;
const ArtDiv = styled.div`
  position: absolute;
  transition: all 0.25s ease-out 0s;
  border: 1px dashed #000;
  margin: 0 auto;
`;

const StockPartner = styled.h3`
  font-weight: 600;
  padding-bottom: 5px;
  margin-bottom: 0px !important;
  font-size: 14px;
  border-bottom: none !important;
  color: ${COLORS.BODY_TEXT};
`;

const StockPartnerInput = styled.div`
  margin-bottom: 20px;
  display: grid;
  flex-direction: row;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  .MuiOutlinedInput-root {
    height: 100%;
  }
`;

const SubHeading = styled.h2`
  font-size: 16px;
  margin: 20px 0;
`;

export {
  Container,
  ProductInformation,
  SelectCategories,
  Update,
  CloudWrapper,
  Wrapper,
  ImageContainer,
  ArtDiv,
  StockPartner,
  StockPartnerInput,
  SubHeading,
};
